import { LearnersSchoolsStudentClass } from "@/types/serializers"
import LearnersChangeWishlistsChangeWishlist, {
  LearnersChangeWishlistsChangeWishlistClassInformationTrait,
  LearnersChangeWishlistsChangeWishlistPriorityInformationTrait,
  LearnersChangeWishlistsChangeWishlistStudentInformationTrait,
} from "@/types/serializers/LearnersChangeWishlistsChangeWishlist"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  students: Array<LearnersSchoolsStudentClass>
  change_wishlists: Array<
    LearnersChangeWishlistsChangeWishlist &
      LearnersChangeWishlistsChangeWishlistClassInformationTrait &
      LearnersChangeWishlistsChangeWishlistStudentInformationTrait &
      LearnersChangeWishlistsChangeWishlistPriorityInformationTrait
  >
  selected_class: {
    class_name: string
    priority_uuid: string
    instance_index: number
  }
}
export const useNewProps = () => useProps<NewProps>()
